import { ApiError } from '@core/api/apiClient';

/**
 * The processor's decline code the backend puts next to a refused charge's copy
 * (`declineCode`, B3 of docs/plans/2026-10-21-mercadopago-approval-hardening.md):
 * MercadoPago's status_detail such as `cc_rejected_high_risk`, Stripe's decline_code,
 * or CARD_REJECTED_RECENTLY from the backend's own retry guard. Null when the body
 * carries none (a pre-payment refusal, a network failure, a non-API error).
 */
export function declineCodeOf(cause: unknown): string | null {
  if (!(cause instanceof ApiError)) return null;
  const code = (cause.body as { declineCode?: unknown } | undefined)?.declineCode;
  return typeof code === 'string' && code.trim() !== '' ? code : null;
}

/** The backend refused the card the guest had just seen refused as high risk, without charging. */
export const CARD_REJECTED_RECENTLY = 'card_rejected_recently';
